var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUncheckedSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#C3D2DF",
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUncheckedSmall);
export default __webpack_public_path__ + "static/media/icon_unchecked_small.5d77824040340580733415c5147b380c.svg";
export { ForwardRef as ReactComponent };